import EMAIL_ICON from "./EMAIL_ICON.png";
import WHATSAPP_ICON from "./WHATSAPP_ICON.png";
import INSTAGRAM_ICON from "./INSTAGRAM_ICON.png";
import NAVBAR_ICON from "./NAVBAR_LOGO.png";

export const ICONS = {
  EMAIL: EMAIL_ICON,
  WHATSAPP: WHATSAPP_ICON,
  INSTAGRAM: INSTAGRAM_ICON,
  NAVBAR_ICON,
};
